import { Map } from 'immutable';

import createTypedReducer from '../createTypedReducer';
import * as deviceListActions from './action';
import { CHANGE_CLIENT, CLEAR } from '../authentication/action';
import type { DeviceListItem } from 'src/service/api/deviceList';

/* Values are plain JS, set with .set() only: the table reads `items` as is. */
export const initialState = Map<string, any>({
  items: [] as DeviceListItem[],
  nextOffset: 0,
  hasMore: false,
  deviceCount: null as number | null,
  loading: false,
  error: null,
  query: null,
});

const reset = () => initialState;

/* Rows can shift between pages while scrolling; keep the first copy of each. */
function append (items: DeviceListItem[], page: DeviceListItem[]): DeviceListItem[] {
  const seen = new Set<string>();
  items.forEach((item) => {
    seen.add(item.id);
    item.circuits.forEach((c) => seen.add(c.id));
  });

  const fresh = page
    .filter((item) => !seen.has(item.id))
    .map((item) => ({ ...item, circuits: item.circuits.filter((c) => !seen.has(c.id)) }));

  return [...items, ...fresh];
}

export const deviceListReducer = createTypedReducer(initialState, {
  [deviceListActions.FETCH_DEVICE_LIST] (state, action) {
    return reset()
      .set('loading', true)
      .set('query', { selectedFilters: action.selectedFilters, sort: action.sort, scope: action.scope });
  },

  [deviceListActions.FETCH_DEVICE_LIST_NEXT_PAGE] (state) {
    return state.set('loading', true);
  },

  [deviceListActions.FETCH_DEVICE_LIST_SUCCESS] (state, action) {
    return state.withMutations((nextState) =>
      nextState
        .set('items', append(state.get('items'), action.page.data))
        .set('nextOffset', action.page.nextOffset)
        .set('hasMore', action.page.hasMore)
        .set('deviceCount', action.page.offset === 0 ? action.page.deviceCount : state.get('deviceCount'))
        .set('loading', false)
    );
  },

  [deviceListActions.FETCH_DEVICE_LIST_FAILED] (state, action) {
    return state.set('loading', false).set('error', action.err);
  },

  [CHANGE_CLIENT]: reset,
  [CLEAR]: reset,
});
